import { render, staticRenderFns } from "./videoPlayYS.vue?vue&type=template&id=5d31a303&scoped=true"
import script from "./videoPlayYS.vue?vue&type=script&lang=js"
export * from "./videoPlayYS.vue?vue&type=script&lang=js"
import style0 from "./videoPlayYS.vue?vue&type=style&index=0&id=5d31a303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31a303",
  null
  
)

export default component.exports